/* 
  Updated Mock Data 
  Added workflow steps and extended sample records for the Demo page.
*/

export const workflowSteps = [
  { id: 1, title: "Rate Procurement", description: "Compare live spot rates across 50+ carriers.", module: "Carrier Comparison", icon: "Compass" },
  { id: 2, title: "Booking Terminal", description: "Secure space and generate digital BL.", module: "Shipment Board", icon: "Layers" },
  { id: 3, title: "Customs Alignment", description: "Automated document verification and filing.", module: "Customs Checklist", icon: "FileText" },
  { id: 4, title: "Transit Watch", description: "Real-time GPS and AIS vessel tracking.", module: "Route Timeline", icon: "Activity" },
  { id: 5, title: "Exception Handling", description: "Proactive resolution of port congestion.", module: "AlertTriangle", icon: "AlertTriangle" },
  { id: 6, title: "Client Delivery", description: "Branded tracking portal for end customers.", module: "Customer Updates", icon: "MessageSquare" },
  { id: 7, title: "Cost Analytics", description: "Post-shipment financial reconciliation.", module: "Cost Summary", icon: "TrendingUp" }
];

export const shipments = [
  {
    id: "FF-8829-CNUS",
    origin: "Shanghai, CN (CNSHA)",
    destination: "Los Angeles, US (USLAX)",
    carrier: "Maersk",
    type: "Sea Freight",
    status: "In Transit",
    eta: "2023-11-15T14:00:00Z",
    progress: 65,
    container: "MSKU8923741",
    priority: "Normal"
  },
  {
    id: "FF-9102-DEGB",
    origin: "Hamburg, DE (DEHAM)",
    destination: "London, GB (GBLON)",
    carrier: "DHL Global",
    type: "Road Freight",
    status: "Customs Hold",
    eta: "2023-10-28T09:00:00Z",
    progress: 40,
    container: "TRK-992-AB",
    priority: "High"
  },
  {
    id: "FF-7731-JPAU",
    origin: "Tokyo, JP (JPTYO)",
    destination: "Sydney, AU (AUSYD)",
    carrier: "FedEx Aviation",
    type: "Air Freight",
    status: "Delivered",
    eta: "2023-10-20T11:30:00Z",
    progress: 100,
    container: "AWB-772-9182",
    priority: "Normal"
  },
  {
    id: "FF-4451-SGSG",
    origin: "Singapore, SG (SGSIN)",
    destination: "Rotterdam, NL (NLRTM)",
    carrier: "CMA CGM",
    type: "Sea Freight",
    status: "Port of Loading",
    eta: "2023-12-05T08:00:00Z",
    progress: 15,
    container: "CMAU1122334",
    priority: "Normal"
  },
  {
    id: "FF-8812-USMX",
    origin: "Chicago, US (USCHI)",
    destination: "Monterrey, MX (MXMTY)",
    carrier: "XPO Logistics",
    type: "Road Freight",
    status: "Exception",
    eta: "2023-10-26T18:00:00Z",
    progress: 50,
    container: "TRK-554-XY",
    priority: "Critical"
  }
];

export const exceptions = [
  {
    id: "EX-091",
    shipmentId: "FF-8812-USMX",
    type: "Weather Delay",
    severity: "High",
    description: "Severe snowstorm at border crossing. Route temporarily impassable.",
    time: "2 hours ago",
    status: "Unresolved"
  },
  {
    id: "EX-092",
    shipmentId: "FF-9102-DEGB",
    type: "Documentation",
    severity: "Critical",
    description: "Missing Commercial Invoice for clearance at Dover.",
    time: "5 hours ago",
    status: "Action Required"
  },
  {
    id: "EX-093",
    shipmentId: "FF-4451-SGSG",
    type: "Port Congestion",
    severity: "Medium",
    description: "Vessel delayed at loading port due to high berth occupancy.",
    time: "1 day ago",
    status: "Monitoring"
  }
];

export const carrierRates = [
  { id: 1, name: "Maersk Line", type: "Sea", transitDays: 24, cost: 4200, reliability: 94, co2: "2.1t" },
  { id: 2, name: "MSC", type: "Sea", transitDays: 26, cost: 3950, reliability: 89, co2: "2.3t" },
  { id: 3, name: "DHL Aviation", type: "Air", transitDays: 4, cost: 12500, reliability: 98, co2: "15.4t" },
  { id: 4, name: "FedEx Express", type: "Air", transitDays: 3, cost: 14200, reliability: 99, co2: "16.1t" },
];

export const routeTimeline = [
  { step: "Booking Confirmed", location: "System", date: "Oct 10, 09:00", status: "completed" },
  { step: "Empty Container Pickup", location: "Depot A", date: "Oct 12, 14:30", status: "completed" },
  { step: "Cargo Stuffed", location: "Shipper Facility", date: "Oct 14, 10:00", status: "completed" },
  { step: "Gate In", location: "Port of Loading", date: "Oct 15, 08:15", status: "completed" },
  { step: "Vessel Departed", location: "Ocean", date: "Oct 17, 22:00", status: "current" },
  { step: "Vessel Arrived", location: "Port of Discharge", date: "Est. Nov 10", status: "pending" },
  { step: "Customs Cleared", location: "Border", date: "Pending", status: "pending" },
  { step: "Delivered to Consignee", location: "Destination", date: "Pending", status: "pending" },
];

export const customsChecklist = [
  { doc: "Bill of Lading", status: "Verified", required: true },
  { doc: "Commercial Invoice", status: "Missing", required: true },
  { doc: "Packing List", status: "Verified", required: true },
  { doc: "Certificate of Origin", status: "Pending Review", required: false },
];